import React, { useState, useEffect, useCallback, useRef } from "react";
import { ICreateProfile, IUpdateProfile } from "../../../../@types";
import { Pen } from "../../../../assets/icons/PenIcon";
import { Tooltip } from "../../../../assets/icons/Tooltip";
import { updateProfile } from "../../../../backend-services";
import { useUserStore } from "../../../../state";
import { GroupButton } from "../../../common";
import { InputComponent } from "../../../core/Forms";
import { useCompanyStore } from "../../../../state/useCompanyStore";
import TooltipDropdown from "../../../common/tooltipDropdown";
import PhoneInputComponent from "../../../common/PhoneInputComponent";
import { CompanyUpdateInput } from "../../../Reusable/SendModal/ReusableSendModal";

interface CreateEditProfileProps {
  onCreateProfile?: (profile: ICreateProfile) => void;
  onClick?: (e?: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  show?: boolean;
  onClose?: () => void;
  toolTipText?: string;
  toolTipText2?: string;
  toolTipText3?: string;
  toolTipText4?: string;
}

const debounce = (func: Function, delay: number) => {
  let timeoutId: NodeJS.Timeout;
  return (...args: any[]) => {
    if (timeoutId) clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      func(...args);
    }, delay);
  };
};

const CompanyUpdate = ({
  onCreateProfile,
  show,
  onClose,
  toolTipText,
  toolTipText2,
  toolTipText3,
  toolTipText4,
}: CreateEditProfileProps) => {
  const { company } = useCompanyStore();

  // Create a ref to hold the previous company data
  const prevUser = useRef(company);
  const [isOpen, setIsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  // const [isEditing, setIsEditing] = useState(false);
  const [isEditing, setIsEditing] = useState(
    company?.prefs?.isFirstInvoice || false,
  );
  const [isHovered, setIsHovered] = useState(false);
  const [isHovered2, setIsHovered2] = useState(false);
  const [isHovered3, setIsHovered3] = useState(false);
  const [isHovered4, setIsHovered4] = useState(false);
  const [, setErrorMessage] = useState("");
  const [formData, setFormData] = useState({
    businessName: company?.businessName || "",
    address: company?.address || "",
    phone: company?.phone || "",
    code: company?.code || "",
  });

  const [errors, setErrors] = useState({
    businessName: "",
    address: "",
    phone: "",
  });

  const validateField = (name: string, value: string) => {
    let error = "";

    switch (name) {
      case "businessName":
        if (value.length < 3) {
          error = "Business name must be at least 3 characters long";
        }
        break;
      case "address":
        if (!value.trim()) {
          error = "Address is required";
        }
        break;
      case "phone":
        if (!/^\d{10,15}$/.test(value)) {
          error = "Phone number must be 10 to 15 digits";
        }
        break;
      default:
        break;
    }

    setErrors((prevErrors) => ({ ...prevErrors, [name]: error }));
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
    validateField(name, value);
  };

  useEffect(() => {
    if (company) {
      setFormData((prevData) => {
        const newData = {
          businessName: company.businessName || "",
          address: company?.address || "",
          phone: company?.phone || "",
          code: company?.code || "",
        };
        // Only update if the new data is different from the previous data
        if (JSON.stringify(prevData) !== JSON.stringify(newData)) {
          return newData;
        }
        return prevData; // Return the previous state if no changes
      });
    }
  }, [company]);

  const update = async (updatedFields: Partial<IUpdateProfile>) => {
    await useCompanyStore.getState().updateCompanyProfile(updatedFields);
  };
  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };
  const handleMouseEnter2 = () => {
    setIsHovered2(true);
  };

  const handleMouseLeave2 = () => {
    setIsHovered2(false);
  };

  const handleMouseEnter3 = () => {
    setIsHovered3(true);
  };

  const handleMouseLeave3 = () => {
    setIsHovered3(false);
  };
  const handleMouseEnter4 = () => {
    setIsHovered4(true);
  };

  const handleMouseLeave4 = () => {
    setIsHovered4(false);
  };

  const toggleEditing = () => {
    setIsEditing((prev: any) => !prev); // Toggles the value of isEditing
  };

  const handlePhoneNumberChange = (phone: any) => {
    setFormData({ ...formData, phone: phone || "" });
  };
  if (!company.companyId) {
    return (
      <>
        <div className=" space-y-4 flex my-5">
          <div className="inset-y-0 right-6 flex items-center mx-auto w-full justify-center">
            <div className="w-7 h-7 border-4 border-gray-200 border-t-[#044E97] rounded-full animate-spin"></div>
          </div>
        </div>
      </>
    );
  }
  return (
    <div id="personalize-invoice" className="lg:mt-[1em] mt-[1.6em]">
      {isEditing || !company?.address || !company?.phone ? (
        <form>
          <h4 className="text-[14px] font-medium leading-5 text-[#000000] lg:hidden md:hidden">
            Business information
          </h4>
          <div className="relative lg:w-[370px]">
            <CompanyUpdateInput
              label="businessName"
              main={formData.businessName}
              placeholder="Your business name"
              isPhone={false}
            />
          </div>

          <div className="relative mt-3 md:mt-5 lg:w-[370px]">
            <CompanyUpdateInput
              label="address"
              main={formData.address}
              placeholder="Your Business Address"
              isPhone={false}
            />
          </div>

          <div className="flex flex-col gap-3 w-full mt-3 md:mt-5 lg:w-[370px]">
            <div className="relative w-full">
              <CompanyUpdateInput
                label="phone"
                main={formData.phone}
                placeholder="Your Phone Number"
                isPhone={true}
              />
            </div>

            <div className="relative w-full">
              <CompanyUpdateInput
                label="code"
                main={formData.code}
                placeholder="Your Company's RC"
                isPhone={false}
              />
            </div>
          </div>
        </form>
      ) : (
        <button
          onClick={toggleEditing}
          type="button"
          className="w-full flex justify-center gap-2 items-center border border-gray-300 py-3 rounded-lg"
        >
          <Pen />
          <p className="font-medium leading-6 text-gray-700">
            Edit business information
          </p>
        </button>
      )}
    </div>
  );
};

export default CompanyUpdate;
